const buildType = require("./models");

const BankAccountType = buildType({
  initializer: (model, document) => {
    model.spanishName = document?.spanishName;
    model.englishName = document?.englishName;
    model.name = document?.name;
    model.hasInterest = document?.hasInterest;
  },
  code: "bankAccountTypes",
  singular: "Bank Account Type",
  plural: "Bank Account Types",
  save: async (type, create, update, database) => {
    const accounts = await database.getList("bankAccounts");
    for (const account of accounts) {
      if (account.type?.id === type.id) {
        account.type = { ...type };
        await database.set("bankAccounts", account.id, account);
      }
    }
    if (!(await update("bankAccountTypes", type))) {
      await create("bankAccountTypes", type);
    }
  },
  afterLoad: (m) => {
    m.name = `${m.spanishName} / ${m.englishName}`;
    m.multiplier = m.multiplier ?? 1;
    return m;
  },
});

module.exports = BankAccountType;
